import { Col, Layout, Row, } from "antd";
import { useEffect, useState } from "react";
import { SingleHeader } from "@components/header";
import { Helmet as Head } from "react-helmet-async";
import { WeeklyTopTenList } from 'src/blocks/weekly-top-ten-list';
import { useGetIssueWeeklyTopTenQuery } from '@mwServices/Issue';
import { Contain } from "@components/layout";


const WeeklyTop10Page = () => {
  const [Data, setData] = useState({
    ID: null,
    title: null,
    slug: null,
    date: null,
    description: null,
    blocks: [],
    author: null,
    type: null,
    image: {
      src: ''
    },
    taxonomy: null,
  });

  const {
    data,
  } = useGetIssueWeeklyTopTenQuery({});


  useEffect(() => {
    if (data) {
      setData(data.results);
    }
  }, [data]);

  return (
    <Layout className="page weekly-top-ten">
      <Head>
        <title>Weekly Top 10</title>
      </Head>
      <Row>
        <Col span={24}>
          <SingleHeader
            className={`hero-header`}
            title={`Weekly Top 10`}
            imgSrc={Data?.image?.src}
            justify="center"
          />
        </Col>
      </Row>
      <Row justify={`center`}>
        <Col span={24}>
          <Contain>
            <WeeklyTopTenList attrs={{
              startCountFrom: '10',
              items: data?.results || []
            }} />
          </Contain>
        </Col>
      </Row>
    </Layout>
  );
};

export default WeeklyTop10Page;


